import { render, staticRenderFns } from "./BlondWaiting3.vue?vue&type=template&id=1e8c779c&"
import script from "./BlondWaiting3.vue?vue&type=script&lang=ts&"
export * from "./BlondWaiting3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports